@if (leerling$ | async; as leerling) {
	<div class="dashboard-toets">
		<app-filter-bar></app-filter-bar>
		<app-filter-panel
			[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
			[allFilters]="allFilters()"
			[leerlingselectie]="false"
			(filterExpressionsChange)="filterExpressions.set($event)"
			endpoint="/cijfers"
			[permanentFilterExpressions]="getVariantPermanentFilters(cijferkolomKeuze(), dossier(), leerling.leerling, variant())"
			[overrideDefault]="getSchooljaarLeerfaseFilterOverride(leerling.schooljaarInfo)"
		></app-filter-panel>
		<section class="dashboard">
			<app-dashboard-header>
				<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
				@if (variant() === DashboardVariant.ACTUEEL) {
					<app-single-select-dropdown
						label="Cijfertype"
						[opties]="cijferkolomKeuzeOpties()"
						[selectedOptie]="getSelectedCijfertypeOptie()"
						(onOptieClicked)="qp.dispatch('cijfertype', $event)"
					></app-single-select-dropdown>
				}
				@if (
					variant() === DashboardVariant.ACTUEEL &&
					cijferkolomKeuze() !== CijferkolomKeuze.GEMIDDELDE &&
					userService.bron() === InstellingBron.Somtoday
				) {
					<app-single-select-dropdown
						label="Toetsdossier"
						[opties]="dossierOpties"
						[selectedOptie]="getSelectedDossierOptie()"
						(onOptieClicked)="qp.dispatch('dossier', $event)"
					></app-single-select-dropdown>
				}
				<app-legenda class="cl-header-utility" [attribute]="['x_cijfer_ov_advies']"></app-legenda>
			</app-dashboard-header>
			<app-pivot-table
				[groups]="[['cf_nm_vak']]"
				[subgroups]="variant() === DashboardVariant.ACTUEEL ? subgroups : historieSubgroups"
				[columnSort]="variant() === DashboardVariant.ACTUEEL ? sortToetsKolommen : sortHistorieKolommen"
				[filters]="filterExpressions()"
				[permanentFilters]="getVariantPermanentFilters(cijferkolomKeuze(), dossier(), leerling.leerling, variant())"
				[config]="this"
			></app-pivot-table>
		</section>
	</div>
}
